import React, { useState } from 'react';
import { Typography, Button, Popover } from '@mui/material';
import { useStyles } from './style';
import {
  Icons,
} from 'components';

let popoverId = 0;

export default function CustomPopover({description = null}) {
  const classes = useStyles();
  const [generatedId] = useState(() => `custom-popover-${++popoverId}`);
  const [showPopover, setShowPopover] = useState(null);
  const handleClick = (event) => {
    setShowPopover(event.currentTarget);
  };

  const handleClose = () => {
    setShowPopover(null);
  };

  const open = Boolean(showPopover);
  return (
    <div className={classes.pagination}>
      <Button
        aria-describedby={generatedId}
  onClick={handleClick}
        className={classes.BIIcon}
        color="primary"
        variant="outlined"
      >
        <Icons icon="Info" color="#303D8F" size="23" />
      </Button>

      <Popover
        id={generatedId}
        open={open}
        anchorEl={showPopover}
        onClose={handleClose}
        className={classes.popover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Typography sx={{ p: 2 }}>
          {description} <br />
          جهت ارتقا سطح مالی از طریق لینک زیر اقدام شود : <br />
          <a target="_blank" href="https://web.wepod.ir/signup/mobile">
            ارتقا سطح مالی
          </a>
        </Typography>
      </Popover>
    </div>
  );
}
